// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main container */
.testing-qa-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 70px;
    background-color:#fff;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    gap: 20px;
}

/* Left Section - Content */
.testing-qa-text {
    width: 60%;
    order: 1; /* Place content on the left */
    border-radius: -150;
    margin-bottom: 100px;
    
}

/* Right Section - Image */
.testing-qa-image {
    position: relative;
    width: 34%;
    order: 2; /* Place image on the right */
    padding: 10px 0;
    margin-top: 0;
}

.services-image {
    width: 100%;
    height: auto;
    border-radius: 8px;
}

/* List styling */
.services-list {
    list-style: none;
    padding: 0;
    margin: 0;
    line-height: 1.5;
}

.services-list ul {
    margin-top: 5px;
    margin-bottom: 15px;
    padding-left: 20px;
}

.services-list li {
    margin-bottom: 10px;
}
.testing-qa-text h1
{
       font-size: 2rem; /* Main headline font size */
        color: #000;
        margin-bottom: 10px;
     
}
.testing-qa-text h2
{
    font-size: 1.5rem; /* Main headline font size */
        color: #555;
        margin-bottom: 10px;
}

/* Responsive Design */
@media (max-width: 768px) {
    .testing-qa-container {
        flex-direction: column;
        align-items: center;
        text-align: left;
        gap: 20px;
    }

    .testing-qa-text {
        width: 130%;
        margin-top:-40px;
    }
    .testing-qa-text h1 {
        width: 100%;
    }

    /* Right Section - Image */
.testing-qa-image {
    position: relative;
    margin-top:70px;
    width: 130%;
    order: 0; /* Place image on the right */
}

.services-image {
    width: 290%;
    height: auto;
   
}
    
}

/* Media Query for 1366x768 screen size */
@media screen and (min-width: 1380px) and (max-width: 1919px) {
    .testing-qa-container {
        padding: 100px; /* Reduced padding for medium screens */
        gap: 15px;
    }

    .testing-qa-text {
        margin-bottom: 80px; /* Adjust spacing for alignment */
    }

    .testing-qa-text h1 {
        font-size: 1.8rem; /* Slightly smaller headline font size */
    }

    .testing-qa-text h2 {
        font-size: 1.3rem; /* Adjusted font size */
    }

    .testing-qa-image {
        width: 32%; /* Slightly increased image width for balance */
    }

    .services-list li {
        font-size: 0.95rem; /* Adjusted list font size */
    }
}

/* Media Query for 1920x1080 screen size */
@media screen and (min-width: 1920px) {
    .testing-qa-container {
        padding: 80px; /* Increased padding for larger screens */
        gap: 25px;
    }

    .testing-qa-text {
        margin-bottom: 120px; /* Increased spacing for better layout */
    }

    .testing-qa-text h1 {
        font-size: 2.2rem; /* Larger headline font size for emphasis */
    }

    .testing-qa-text h2 {
        font-size: 1.7rem; /* Increased secondary headline size */
    }

    .testing-qa-image {
        width: 32%; /* Slightly reduced image width for better proportion */
    }

    .services-list li {
        font-size: 1.1rem; /* Larger font size for better readability */
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/TestingAndQA/TestingAndQA.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB,wCAAwC;IACxC,SAAS;AACb;;AAEA,2BAA2B;AAC3B;IACI,UAAU;IACV,QAAQ,EAAE,8BAA8B;IACxC,mBAAmB;IACnB,oBAAoB;;AAExB;;AAEA,0BAA0B;AAC1B;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ,EAAE,6BAA6B;IACvC,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA,iBAAiB;AACjB;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;AACA;;OAEO,eAAe,EAAE,4BAA4B;QAC5C,WAAW;QACX,mBAAmB;;AAE3B;AACA;;IAEI,iBAAiB,EAAE,4BAA4B;QAC3C,WAAW;QACX,mBAAmB;AAC3B;;AAEA,sBAAsB;AACtB;IACI;QACI,sBAAsB;QACtB,mBAAmB;QACnB,gBAAgB;QAChB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,WAAW;IACf;;IAEA,0BAA0B;AAC9B;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,QAAQ,EAAE,6BAA6B;AAC3C;;AAEA;IACI,WAAW;IACX,YAAY;;AAEhB;;AAEA;;AAEA,yCAAyC;AACzC;IACI;QACI,cAAc,EAAE,uCAAuC;QACvD,SAAS;IACb;;IAEA;QACI,mBAAmB,EAAE,iCAAiC;IAC1D;;IAEA;QACI,iBAAiB,EAAE,wCAAwC;IAC/D;;IAEA;QACI,iBAAiB,EAAE,uBAAuB;IAC9C;;IAEA;QACI,UAAU,EAAE,+CAA+C;IAC/D;;IAEA;QACI,kBAAkB,EAAE,4BAA4B;IACpD;AACJ;;AAEA,0CAA0C;AAC1C;IACI;QACI,aAAa,EAAE,yCAAyC;QACxD,SAAS;IACb;;IAEA;QACI,oBAAoB,EAAE,wCAAwC;IAClE;;IAEA;QACI,iBAAiB,EAAE,2CAA2C;IAClE;;IAEA;QACI,iBAAiB,EAAE,sCAAsC;IAC7D;;IAEA;QACI,UAAU,EAAE,uDAAuD;IACvE;;IAEA;QACI,iBAAiB,EAAE,4CAA4C;IACnE;AACJ","sourcesContent":["/* Main container */\n.testing-qa-container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 70px;\n    background-color:#fff;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    gap: 20px;\n}\n\n/* Left Section - Content */\n.testing-qa-text {\n    width: 60%;\n    order: 1; /* Place content on the left */\n    border-radius: -150;\n    margin-bottom: 100px;\n    \n}\n\n/* Right Section - Image */\n.testing-qa-image {\n    position: relative;\n    width: 34%;\n    order: 2; /* Place image on the right */\n    padding: 10px 0;\n    margin-top: 0;\n}\n\n.services-image {\n    width: 100%;\n    height: auto;\n    border-radius: 8px;\n}\n\n/* List styling */\n.services-list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    line-height: 1.5;\n}\n\n.services-list ul {\n    margin-top: 5px;\n    margin-bottom: 15px;\n    padding-left: 20px;\n}\n\n.services-list li {\n    margin-bottom: 10px;\n}\n.testing-qa-text h1\n{\n       font-size: 2rem; /* Main headline font size */\n        color: #000;\n        margin-bottom: 10px;\n     \n}\n.testing-qa-text h2\n{\n    font-size: 1.5rem; /* Main headline font size */\n        color: #555;\n        margin-bottom: 10px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .testing-qa-container {\n        flex-direction: column;\n        align-items: center;\n        text-align: left;\n        gap: 20px;\n    }\n\n    .testing-qa-text {\n        width: 130%;\n        margin-top:-40px;\n    }\n    .testing-qa-text h1 {\n        width: 100%;\n    }\n\n    /* Right Section - Image */\n.testing-qa-image {\n    position: relative;\n    margin-top:70px;\n    width: 130%;\n    order: 0; /* Place image on the right */\n}\n\n.services-image {\n    width: 290%;\n    height: auto;\n   \n}\n    \n}\n\n/* Media Query for 1366x768 screen size */\n@media screen and (min-width: 1380px) and (max-width: 1919px) {\n    .testing-qa-container {\n        padding: 100px; /* Reduced padding for medium screens */\n        gap: 15px;\n    }\n\n    .testing-qa-text {\n        margin-bottom: 80px; /* Adjust spacing for alignment */\n    }\n\n    .testing-qa-text h1 {\n        font-size: 1.8rem; /* Slightly smaller headline font size */\n    }\n\n    .testing-qa-text h2 {\n        font-size: 1.3rem; /* Adjusted font size */\n    }\n\n    .testing-qa-image {\n        width: 32%; /* Slightly increased image width for balance */\n    }\n\n    .services-list li {\n        font-size: 0.95rem; /* Adjusted list font size */\n    }\n}\n\n/* Media Query for 1920x1080 screen size */\n@media screen and (min-width: 1920px) {\n    .testing-qa-container {\n        padding: 80px; /* Increased padding for larger screens */\n        gap: 25px;\n    }\n\n    .testing-qa-text {\n        margin-bottom: 120px; /* Increased spacing for better layout */\n    }\n\n    .testing-qa-text h1 {\n        font-size: 2.2rem; /* Larger headline font size for emphasis */\n    }\n\n    .testing-qa-text h2 {\n        font-size: 1.7rem; /* Increased secondary headline size */\n    }\n\n    .testing-qa-image {\n        width: 32%; /* Slightly reduced image width for better proportion */\n    }\n\n    .services-list li {\n        font-size: 1.1rem; /* Larger font size for better readability */\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
